<template>
  <footer class="site-footer" :class="{ 'is-en': isEn }">
    <div class="stage">
      <img class="icon phone" :src="phoneIcon" alt="">
      <span class="phone">0755-21010347</span>
      <img class="icon pin" :src="fileUrl('shared/底部电话图标.png')" alt="">
      <span class="address">{{ copy.footer.address }}</span>
      <div class="copyright">Copyright @ 2019-2026 环海运通 All rights reserved.</div>
    </div>
  </footer>
</template>

<script>
import { fileUrl } from '@/utils/fileUrl'
import { getCopy } from '@/locale'

export default {
  name: 'SiteFooter',
  data() {
    return {
      /** 听筒图标没有单独上传，沿用官网原图；文件服务器上的「底部电话图标」实际是地址定位图 */
      phoneIcon: 'https://www.ht-cargo-shipping.com/img/upimages/pkgimg/pkgimg/pkgimg/yunshu/20170103104557503.png'
    }
  },
  computed: {
    /** 是否英文站 */
    isEn() {
      return this.$route.meta && this.$route.meta.lang === 'en'
    },
    /** 按路由语言取页脚文案 */
    copy() {
      return getCopy(this.isEn ? 'en' : 'zh')
    }
  },
  methods: {
    /** 拼接文件服务器上的图片地址 */
    fileUrl(path) {
      return fileUrl(path)
    }
  }
}
</script>

<style scoped>
.site-footer {
  height: 210px;
  background: #282828;
}
.stage {
  position: relative;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
}
.icon {
  position: absolute;
  width: 28px;
  height: 34px;
}
.icon.phone { top: 77px; left: 18.166667%; }
.icon.pin { top: 75px; left: 38.083333%; }
.phone,
.address {
  position: absolute;
  top: 79px;
  color: #666;
  font-size: 16px;
  line-height: 30px;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}
.phone { left: 21.083333%; }
.address { left: 41.083333%; width: 32.5%; }
.site-footer.is-en .address {
  width: 48%;
  line-height: 22px;
  white-space: normal;
}
.copyright {
  position: absolute;
  top: 161px;
  left: 28.416667%;
  width: 43.166667%;
  margin: 0;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  color: #666;
  font-family: Verdana, sans-serif;
}
@media (min-width: 641px) and (max-width: 1200px) {
  .site-footer { height: 196px; }
  .icon.phone { top: 53px; left: 6.28811%; }
  .icon.pin { top: 53px; left: 29.934385%; height: 31px; }
  .phone { top: 51px; left: 9.913507%; }
  .address { top: 53px; left: 33.370891%; width: 17%; }
  .copyright { top: 151px; left: calc(50% - 251px); width: 502px; }
}
@media (max-width: 640px) {
  .site-footer { height: auto; padding: 20px 12px; }
  .stage { height: auto; text-align: center; }
  .icon,
  .phone,
  .address,
  .copyright {
    position: static;
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .icon { width: 22px; height: 26px; margin-right: 6px; }
  .phone { margin-right: 20px; }
  .copyright { display: block; width: 100%; margin-top: 12px; }
}
</style>
